import React, { FC, useCallback, useEffect, useState, useContext } from 'react';
import {
    makeStyles,
    TableRow,
    TableCell,
    FormControl,
    Select,
    MenuItem,
    TextField,
    Table,
    TableHead,
    Checkbox
} from '@material-ui/core';

import { TasksContext, TasksDispatchContext, TasksProvider, useTask } from '../stateManagement/context';



import { ComponentTypeID, IControlMeasure, IControlMeasureAssessment, IControlMeasureCost } from '../types/types';
import { CostAdequacy, order_of_mag } from './control_measure_cost';
import InvestigationsCell from './investigationscell';
import Comments from './comments';


const useStyles = makeStyles((theme) => ({
    button: {
        display: 'block',
        marginTop: theme.spacing(2),
    },
    formControl: {
        margin: theme.spacing(1),
        minWidth: 300,
        maxWidth: 400,
        whiteSpace: "normal",
        fontSize: 14,
    },
    menu: {
        width: 200,
        whiteSpace: "normal",
        fontSize: 14,
    },
    listItem: {
        whiteSpace: "normal",
        fontSize: 14,
    }
}));

interface ControlMeasureAssessmentRowProps {
    control_measure: IControlMeasure;
    write_access?: boolean;
    control_measure_assessment: IControlMeasureAssessment;
    control_measure_cost: IControlMeasureCost
    comment_id: number;
    updateControlMeasureAssessment: (assessment: IControlMeasureAssessment) => void;
}

const ControlMeasureAssessmentRow: FC<ControlMeasureAssessmentRowProps> = ({
    control_measure,
    write_access = false,
    control_measure_assessment,
    control_measure_cost,
    comment_id,
    updateControlMeasureAssessment
}) => {
    const classes = useStyles();

    let dispatch = useContext(TasksDispatchContext)
    let tasks = useTask()


    const [currentControlMeasureAssessment, setCurrentControlMeasureAssessment] = useState<IControlMeasureAssessment>(control_measure_assessment);
    const [controlMeasureAssessments, setControlMeasureAssessments] = useState<IControlMeasureAssessment[]>([]);

    const getCMeasureAssessments = (cm: IControlMeasure): IControlMeasureAssessment[] => {

        let cm_id = cm.uuid
        if (!cm_id)
            cm_id = -1
        return controlMeasureAssessments.filter(cma => cma.control_measure_id === cm_id)

    }

    const checkControlMeasureProperty = (control_measure: IControlMeasure, property: keyof IControlMeasureAssessment) => {
        let cmas = getCMeasureAssessments(control_measure)
        return cmas.some((cma) => cma[property] === true)
    }


    useEffect(() => {
        if (tasks.loaded) {
            setControlMeasureAssessments(tasks.controlMeasureAssessments)

        }

    }, [tasks])


    return (
        <>

            <Table stickyHeader={true} style={{ backgroundColor: "#FFFFFF" }}>
                <TableHead>
                    <TableCell width={30}>de Minimis?</TableCell>
                    <TableCell width={30}>Good Practice & Precedence </TableCell>
                    <TableCell width={30}>Order of magnitude of Costs ($M)</TableCell>
                    <TableCell width={60}>Justification based on Cost (DF) </TableCell>
                    <TableCell>Overall Assessment</TableCell>
                    <TableCell width={"50%"}>Justification</TableCell>
                    <TableCell >Investigation</TableCell>
                    <TableCell>Comments</TableCell>
                </TableHead>

                <TableRow>
                    <TableCell>
                        <Checkbox
                            checked={checkControlMeasureProperty(control_measure, "de_minimis")}
                            disabled={true}
                            color="primary"
                        />
                    </TableCell>
                    <TableCell>
                        <Checkbox
                            checked={checkControlMeasureProperty(control_measure, "good_practice")}
                            disabled={true}
                            color="primary"
                        />
                    </TableCell>
                    <TableCell
                        style={{ whiteSpace: "nowrap" }}>
                        {order_of_mag(control_measure_cost)}
                    </TableCell>
                    <TableCell style={{ textAlign: "center", whiteSpace: "nowrap" }}>
                        {CostAdequacy(control_measure_cost)}<br />
                        ({(control_measure_cost.df) ? (control_measure_cost.df) > 25000 ? "> 25,000" : Number(control_measure_cost.df.toFixed(0)).toLocaleString() : "-"})
                    </TableCell>


                    <TableCell>
                        <FormControl className={classes.formControl} margin='dense'>
                            <Select
                                MenuProps={{ className: classes.menu }}
                                value={currentControlMeasureAssessment.overall_assessment_id}
                                disabled={!write_access}
                                onChange={(event) => {
                                    let value = parseInt(event.target.value as string)
                                    // check if value is undefined

                                    if (value !== undefined) {
                                        let c = { ...currentControlMeasureAssessment }
                                        c.overall_assessment_id = value
                                        setCurrentControlMeasureAssessment(c)
                                        updateControlMeasureAssessment({ ...c })

                                    }
                                }}
                            >
                                <MenuItem className={classes.listItem} value={0}></MenuItem>
                                <MenuItem className={classes.listItem} value={1}>Reasonably Practicable</MenuItem>
                                <MenuItem className={classes.listItem} value={2}>Reasonably Practicable (tentative)</MenuItem>
                                <MenuItem className={classes.listItem} value={3}>Not Reasonably Practicable (tentative)</MenuItem>
                                <MenuItem className={classes.listItem} value={4}>Not Reasonably Practicable</MenuItem>
                                <MenuItem className={classes.listItem} value={5}>Cannot Determine at this Time</MenuItem>
                            </Select>
                        </FormControl>
                    </TableCell>
                    <TableCell>
                        <TextField
                            style={{ width: '100%' }}
                            inputProps={{ style: { fontSize: "11pt" } }}
                            id="standard-number"
                            multiline={true}
                            disabled={!write_access}
                            size={"small"}
                            value={currentControlMeasureAssessment.overall_justification}
                            InputLabelProps={{
                                shrink: true,

                            }}

                            InputProps={{
                                style: { fontSize: 14 },
                            }}
                            onChange={(event) => {
                                let v = event.target.value
                                let c = { ...currentControlMeasureAssessment }
                                c.overall_justification = v
                                setCurrentControlMeasureAssessment(c)
                            }}
                            onBlur={
                                (event) => {
                                    let v = event.target.value
                                    let c = { ...currentControlMeasureAssessment }
                                    c.overall_justification = v
                                    updateControlMeasureAssessment({ ...c })
                                }
                            }
                        />
                    </TableCell>

                    <TableCell>
                        <InvestigationsCell writeAccess={write_access} elementUUID={control_measure.uuid} linkType={ComponentTypeID.AdditionalControlMeasuer} />
                    </TableCell>
                    <TableCell>
                        {control_measure.uuid && <Comments parent_uuid={parseInt("" + comment_id + control_measure.uuid)} type_id={ComponentTypeID.ReasonablyPracticable} />}
                    </TableCell>

                </TableRow>
            </Table>
        </>

    );
};

export default ControlMeasureAssessmentRow;